import { Router } from '@angular/router';
import { BaseDataModel, ResponseType, RouteMessage } from 'common/models/utilitymodels/base.model';
import { HeadersList, ListComponentData, ListModel, MinMaxFilter } from 'common/models/utilitymodels/list.model';
import { BaseResolver } from './base.resolver';
import { ListDataWidgetService } from 'common/services/core_services/list.data.widget.service';

export abstract class ListResolverService<T extends BaseDataModel, G extends ListModel<T>> extends BaseResolver<T> {
    protected constructor(protected ls: ListDataWidgetService<T, G>, protected router: Router) {
        super(ls, router);
    }

    modifyComponentData(componentData: ListComponentData): ListComponentData {
        return componentData;
    }

    initComponentData(): ListComponentData {
        const componentData: any = this.getComponentData();
        const metaModel = this.ls.getMetaModel();
        componentData.recordPerPage = metaModel.properties.recordPerPage;
        componentData.selectedPage = 1;
        for (const header of metaModel.properties.listInfo) {
            if (header.isSerchable === true) {
                componentData.sortingFeild = header;
                componentData.sortingFeild.sortingOrder = '1';
                break;
            }
        }
        const filterFeilds: string[] = [];
        const minMaxFilter: MinMaxFilter[] = [];
        metaModel.properties.listInfo.forEach((header: HeadersList) => {
            if (header.isSerchable) {
                filterFeilds.push(header.keyName);
            }
            if (header.isMinMaxSort && header.feildType === 'number') {
                const filter = new MinMaxFilter();
                filter.fieldName = header.keyName;
                filter.rangeValue = { min: null, max: null };
                minMaxFilter.push(filter);
            }
        });
        componentData.searchableFeilds = filterFeilds;
        componentData.minMaxFilter = minMaxFilter;
        const finalComponentData = this.modifyComponentData(componentData);
        return finalComponentData;
    }

    patchBackActionData(message: RouteMessage) {
        return new Promise<ResponseType<T>>((resolve, reject) => {
            const responseType = new ResponseType<T>();
            responseType.data = message.transferData.pageData;
            responseType.meta = message.transferData.pageMeta;
            responseType.componentData = message.transferData.componentData;
            responseType.componentData.actionType = message.type;
            responseType.queryParams = message.transferData.queryParams;
            resolve(responseType);
        });
    }
}
